export default __webpack_public_path__ + "static/4-91385f23069ef476888087f37514b593.jpg";